import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'icon';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  fullWidth = false,
  className = '',
  ...props 
}) => {
  // Added touch-manipulation to prevent double-tap to zoom and speed up click events
  // refined active scale for mobile feel
  const baseStyles = "inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg active:scale-[0.96] transform touch-manipulation select-none";
  
  const variants = {
    primary: "bg-brand-800 text-white hover:bg-brand-900 focus:ring-brand-500 shadow-sm border border-transparent",
    secondary: "bg-brand-100 text-brand-900 hover:bg-brand-200 focus:ring-brand-500 border border-transparent",
    outline: "border border-slate-300 text-slate-700 bg-white hover:bg-slate-50 focus:ring-slate-400",
    ghost: "text-brand-800 hover:bg-brand-50 hover:text-brand-900 bg-transparent",
    icon: "bg-transparent text-slate-600 hover:text-brand-800 hover:bg-slate-100 p-2", // New icon variant
  };

  const sizes = {
    sm: "px-4 py-2.5 text-sm", // Increased vertical padding for touch target accessibility
    md: "px-5 py-3 text-base",
    lg: "px-8 py-4 text-lg",
  };

  const widthClass = fullWidth ? "w-full" : "";
  const sizeClass = variant === 'icon' ? '' : sizes[size];

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizeClass} ${widthClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};